/**
 * Nome amigável de cada módulo, usado apenas para montar o texto do tooltip de bloqueio
 * (ex.: "Acesso restrito para os módulos: Simulador, Qualifica").
 *
 * Este arquivo NÃO controla acesso: o acesso, o cadeado e a lista de módulos que
 * liberam cada funcionalidade vêm do back-end (ver `PermissaoService`).
 */

export type ModuleKey =
  | 'essencial'
  | 'simulador'
  | 'qualifica'
  | 'premium'
  | 'redimensiona'
  | 'bmtiss'
  | 'monitor'
  | 'revisor';

/**
 * Mapeamento de código do módulo para nome amigável exibido ao usuário.
 * Deve conter todos os módulos de `apl_modulo`; códigos não mapeados são exibidos como vieram.
 */
export const MODULE_DISPLAY_NAMES: Record<ModuleKey, string> = {
  essencial: 'Essencial',
  simulador: 'Simulador',
  qualifica: 'Qualifica',
  premium: 'Premium',
  redimensiona: 'Redimensiona',
  bmtiss: 'BM TISS',
  monitor: 'Monitor',
  revisor: 'Revisor',
};

export const CONTACT_URL = 'https://blendus.com.br/fale-conosco';
